<!-- Empty file to load sub-url-path into deep level
     DO NOT DELETE THIS FILE -->
<template>
  <div class="auth-area">
    <div class="row">
      <div class="col-auto fixed-top-right">
        <FreshWidgetButton
          class="q-ma-md"
          :custom-props="{ round: true, color: 'white text-primary', icon: 'fas fa-headset' }"
        ></FreshWidgetButton>
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
import { FreshWidgetButton } from 'src/application/global/components'

export default {
  components: {
    FreshWidgetButton,
  },
}
</script>
